
































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import publishObjectPath from '@/util/configRegistry';
import { performanceServer, siteManagementServer } from '@/api/installServer';
import safetyChecklist from '@/views/inspectionContents/checklist/detailUnit/safetyChecklist.vue';
import hiddenForm from '@/views/inspectionContents/checklist/detailUnit/hiddenForm.vue';

@Component({
  components: { safetyChecklist, hiddenForm },
  mixins: [TableStripe],
})
export default class WorkOrderDetailsDialog extends Vue {
  visible: any = false;
  rowId: any = {};
  loading: any = false;

  private activeName: any = 'safetyChecklist'; // 默认显示安全检查单

  private currentIndex: any = -1;

  private handleClick(tab: any, event: any) {
    this.rowId.index = tab.index;
  }

  private hiddenData: any = [];
  private exportLoading = false; // 导出的加载
  private serverUrl = publishObjectPath.serverUrl;

  private serverUrlImg = publishObjectPath.imgPathWater;
  // 安全检查的表格
  private tableData: any = {
    receiptCode: '',
  };
  // 隐患的表格
  private hazards: any = []; // 所有隐患的数组
  private allPeople: any = []; // 参与领导、参与人员合并的数组

  showDialog(row: any) {
    this.loading = true;
    this.rowId = row;
    this.visible = true;
    this.activeName = 'safetyChecklist';

    this.getHiddenFormNum();
    this.getCheckDetail();
  }

  created() {
    // this.getHiddenFormNum();
    // this.getCheckDetail();
  }

  // 获取隐患整改单的数据（个数和详情）
  private getHiddenFormNum() {
    performanceServer.getRectifyFormDetail(this.rowId.id).then((res: any) => {
      // console.log(res);
      if (res.code === '200') {
        this.hiddenData = res.data;
        if (this.hiddenData.length > 0) {
          this.hiddenData.forEach((data: any, index: any) => {
            // console.log(data, index);
          });
        }
      } else {
        this.$message.warning(res.msg);
      }
    });
  }
  // 获取安全检查单详情
  private getCheckDetail() {
    // 查询安全检查任务详情
    performanceServer.getTemplateDetail(this.rowId.id).then((res: any) => {
      if (res.code === '200') {
        this.tableData = res.data; //安全检查单的数据
        this.allPeople = this.unique(res.data.joinLeaderList.concat(res.data.joinStaffList));
        this.hazards = res.data.hazards; // 下面隐患的数据
        // console.log(this.hazards);
        // 调接口以显示图片
        this.hazards.forEach((id: any, index: any) => {
          this.$set(id, 'pic', []);
          this.getSysFile(id);
        });
        this.loading = false;
      } else {
        this.$message.warning(res.msg);
      }
    });
  }
  /* el-image图片放大时的默认旋转 */
  private imgPreview(e: any) {
    setTimeout(() => {
      const dom: any = document.getElementsByClassName('el-image-viewer__img');
      for (let i = 0; i < dom.length; i++) {
        dom[i].style.transform = 'scale(1) rotate(270deg)';
      }
    });
  }

  private unique(arr: any) {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i].staffId === arr[j].staffId || arr[i].staffId === undefined || arr[j].staffId === undefined) {
          // 第一个等同于第二个，splice方法删除第二个
          arr.splice(j, 1);
          j--;
        }
      }
    }
    return arr;
  }

  private getSysFile(ids: any) {
    performanceServer.getSysFile(ids.hazardPicture).then((res: any) => {
      if (res.code === '200' && res.data && res.data.length > 0) {
        ids.pic = res.data;
      }
    });
  }

  /**
   * 返回
   * */
  private backToIndex() {
    this.$emit('backToIndex');
  }

  /**
   * 导出检查单
   * */
  // printMethodCheck() {
  //   document.documentElement.scrollTop = 0;
  //   const canvas: any = document.createElement('canvas'); // 生成canvas上下文
  //   const context = canvas.getContext('2d');
  //   const _articleHtml: any = document.getElementById('checkForm');
  //   const _w = _articleHtml.clientWidth; //获取需要导出pdf区域的宽度和高度
  //   let _h = _articleHtml.clientHeight;
  //   const scale = 3;
  //   if (_w > _h) {
  //     _h = _w;
  //   }
  //   canvas.width = _w * scale;
  //   canvas.height = _h * scale;
  //   context.scale(scale, scale);
  //   const opts = {
  //     scale: 1,
  //     width: _w, //dom 原始宽度
  //     height: _h,
  //     canvas: canvas,
  //     useCORS: true, //允许canvas画布内可以跨域请求外部链接图片, 允许跨域请求。
  //   };
  //   // 以上部分都是为了强化清晰度的，放大canvas画布
  //   html2canvas(_articleHtml, opts).then(canvas => {
  //     this.createPdfAll(canvas, scale);
  //   });
  // }
  // createPdfAll(canvas: any, scale: any) {
  //   const contentWidth = canvas.width / scale;
  //   const contentHeight = canvas.height / scale;
  //   const pdf = new jsPDF('p', 'pt', [contentWidth, contentHeight]); //自定义宽高
  //   const pageData = canvas.toDataURL('image/jpeg', 1.0); //转换图片为dataURL
  //   pdf.addImage(pageData, 'JPEG', 0, 0, contentWidth, contentHeight); //添加图像到页面
  //   pdf.save(`检查单  ${this.tableData.receiptCode}.pdf`);
  // }
}
